export default {
  assetNotSupported: '{assetDisplayName} ist entweder keiner Datenquelle zugeordnet oder hat keine eigene Ansicht in der Fernsteuerung.',
};
